angular.module('app.factories').factory('UserService', ($rootScope, $sessionStorage, $http, $q, $log, $timeout, $injector, variables) => {
    const expireTime = 12 * 3600 * 1000; // 12h

    const now = new Date().getTime();

    const DefaultUser = {
        auth: false,
        data: {},
        permissions: {},
        groups: [],
        expire: 0,
    };

    $sessionStorage.$default({
        User: DefaultUser,
    });

    if ($sessionStorage.User.auth && $sessionStorage.User.expire > now) {
        $sessionStorage.User.expire = now + expireTime;
    } else {
        $sessionStorage.User = DefaultUser;
    }

    return {
        afterSuccess(response, deferred, changeArea = false) {
            $log.debug('--> Login:afterSuccess', response, 'changeArea = ', changeArea);
            if (response.data && response.data.result) {
                $sessionStorage.User.auth = true;
                $sessionStorage.User.data = response.data.user;
                $sessionStorage.User.permissions = response.data.permissions;
                $sessionStorage.User.groups = response.data.groups;
                $sessionStorage.User.areas = response.data.areas;
                $sessionStorage.User.expire = now + expireTime;

                if (changeArea) {
                    $injector.invoke((areasService) => {
                        areasService.changeArea(response.data.area_id);
                    });
                }

                this.setupUser();

                deferred.resolve();
            } else {
                $sessionStorage.User = DefaultUser;

                deferred.reject({
                    message: response.data.message,
                });
            }
        },

        afterFailure(response, deferred) {
            $sessionStorage.User = DefaultUser;

            deferred.reject({
                message: 'request_error',
            });
        },

        login(credentials) {
            const deferred = $q.defer();
            const that = this;

            $http({
                method: 'post',
                url: '/api/1/auth',
                data: credentials,
            }).then(
                (response) => {
                    that.afterSuccess(response, deferred, true);
                },
                (response) => {
                    that.afterFailure(response, deferred);
                }
            );

            return deferred.promise;
        },

        checkSessions() {
            $log.debug('--> Login:checkSessions');
            const deferred = $q.defer();
            const that = this;

            $http({
                method: 'post',
                url: '/api/1/auth/autologin',
            }).then(
                (response) => {
                    that.afterSuccess(response, deferred, true);
                },
                (response) => {
                    that.afterFailure(response, deferred);
                }
            );

            return deferred.promise;
        },

        refreshData(userData) {
            $log.debug('--> Login:refreshData');
            const deferred = $q.defer();
            const that = this;

            if ('undefined' === typeof userData) {
                $http({
                    method: 'post',
                    url: '/api/1/auth/userdata',
                }).then(
                    (response) => {
                        that.afterSuccess(response, deferred, true);
                    },
                    (response) => {
                        that.afterFailure(response, deferred);
                    }
                );

                return deferred.promise;
            } else {
                that.afterSuccess(userData, deferred);
            }
        },

        logout(callback) {
            $sessionStorage.User.auth = false;
            $sessionStorage.$reset({
                User: DefaultUser,
            });

            $timeout(() => {
                $http({
                    method: 'post',
                    url: '/api/1/auth/logout',
                }).then(() => {
                    if ('function' === typeof callback) {
                        callback();
                    }
                });
            }, 250);

            return true;
        },

        isAuthenticated() {
            return $sessionStorage.User.auth || false;
        },

        isAllowed(permission, modelAreaId) {
            if (!this.isAuthenticated() || 'object' !== typeof $sessionStorage.User.permissions) {
                $log.debug('--> Check permissions: not authenticated / bad permissions');
                return false;
            }

            // grupa adminów?
            // @todo: rethink+refactor (security)
            if ($sessionStorage.User.permissions.indexOf('admin_group') || $sessionStorage.User.permissions.indexOf('admin_system')) {
                $log.debug('--> Check permissions: admin');
                return true;
            }

            let isAllowed = false;
            const validArea = 0 === modelAreaId || modelAreaId === $rootScope.$session.area.id;

            _.map(permission, (validFor, permissionName) => {
                // używamy do zastąpienia - current user id
                if ('CUID' === validFor) {
                    validFor = $sessionStorage.User.data.id;
                }

                // występuje takie uprawnienie, np. profile__read
                const keyMatch = $sessionStorage.User.permissions.includes(permissionName);
                // występuje wartość, np. task__write__all:0 lub task__write:[1, 2]
                const valueMatch = 0 == validFor || validFor == $sessionStorage.User.data.id || (validFor.length && validFor.includes($sessionStorage.User.data.id));
                // stała
                const isTrue = 'true' === permissionName;

                isAllowed = isAllowed || isTrue || (validArea && keyMatch && valueMatch);
            });

            $log.debug('--> Check permissions:', isAllowed, modelAreaId, permission);

            return isAllowed;
        },

        // @TODO: test and rewrite
        getUser(forceRefresh) {
            const toRefresh = forceRefresh || false;
            let userObject = angular.extend({}, $sessionStorage.User.data);

            if (toRefresh) {
                $http({
                    method: 'post',
                    url: '/api/1/auth/userdata',
                }).then((response) => {
                    $sessionStorage.User.data = response.data.user;
                    $sessionStorage.User.permissions = response.data.permissions;
                    $sessionStorage.User.groups = response.data.groups;
                    $sessionStorage.User.areas = response.data.areas;
                    $sessionStorage.User.auth = response.result;

                    $timeout(() => {
                        userObject = angular.extend({}, $sessionStorage.User.data);
                    });
                });
            }

            return userObject;
        },

        getUserGroups() {
            return angular.extend([], $sessionStorage.User.groups || []);
        },

        setUser(data) {
            $sessionStorage.User.data = data;

            this.setupUser();
        },

        passwordReset(email) {
            const deferred = $q.defer();

            $http({
                method: 'post',
                url: 'password/email',
                data: { email },
            }).then((response) => {
                if (200 === response.status) {
                    deferred.resolve(response.data);
                } else {
                    deferred.reject(response.data);
                }
            });

            return deferred.promise;
        },

        setupUser(forceSettings) {
            if (!this.isAuthenticated()) {
                return false;
            }

            const settings = angular.extend({}, $sessionStorage.User.data.settings || {}, forceSettings || {});
            $sessionStorage.User.data.settings = settings;

            $rootScope.mainTheme = settings.theme || variables.default_theme;
            $rootScope.highContrastActive = settings.highContrast || variables.default_high_contrast;
            $rootScope.miniSidebarActive = settings.miniSidebar || variables.default_mini_sidebar;
            $rootScope.boxedLayoutActive = settings.boxedLayout || variables.default_boxed_layout;
            $rootScope.userAreaId = $sessionStorage.User.data.area_id;
        },
    };
});
